import { User } from "@auth/user";
import useAuth from "@fuse/core/FuseAuthProvider/useAuth";

type useUser = {
	data: User | null;
	isGuest: boolean;
	signOut: () => void;
};

function useUser(): useUser {
	const { authState, signOut } = useAuth();
	const user = authState?.user as User;
	const isGuest = !user?.permissoes || user.permissoes.length === 0;

	async function handleSignOut() {
		return signOut();
	}

	return {
		data: user,
		isGuest,
		signOut: handleSignOut,
	};
}

export default useUser;
